

get_example = -> 
  loc = fetch 'location'
  parts = loc.url.split('/')

  id =  if parts.length < 3 
          'seattle'
        else 
          parts[parts.length - 1]

  if id == 'public_engagement'
    id = 'seattle'
  else if id == 'strategic_planning'
    id = 'wsffn'
  else if id == 'decentralized_decisions'
    id = 'dao'
  else if id == 'community_visioning'
    id = 'aina'

  cases[id]

set_example = (example) -> 
  loc = fetch 'location'
  loc.url = "/examples/#{example.class or example.id}"
  save loc

window.ExamplesPage = ReactiveComponent
  displayName: 'LandingPage'

  render: -> 

    active_example = get_example()
    DIV 
      style: 
        paddingTop: 60 

      ExampleTabs 
        examples: [
          {case: cases.seattle, label: 'Public Engagement'}
          {case: cases.wsffn, label: 'Strategic Planning'}
          {case: cases.aina, label: 'Community Visioning'}          
          {case: cases.dao, label: 'Decentralized Decisions'}
        ]

      Example 
        case: active_example


  heading: -> 
    DIV 
      style: 
        paddingTop: 40
        width: "var(--SAAS_PAGE_WIDTH)"
        margin: 'auto'
        textAlign: 'center'

      H1
        className: 'main_callout'

        "What is your need for a dialogue?"


styles += """
  [data-widget="ExampleTabs"] {
    width: 100%;
    z-index: 2;
    position: relative;
    top: 2px;
  }

  [data-widget="ExampleTabs"] .example_tab {
    display: inline-block;
    font-size: #{responsive_css_rule({min_size: 18, max_size: 22, min_vw: 980, max_vw: 1100})};
    font-weight: 400;
    padding: 14px 30px 4px 30px;
    color: white;
    cursor: pointer;
    position: relative;
  }

  @media (max-width: 760px) {
    [data-widget="ExampleTabs"] {
      margin-bottom: 24px;
    }
  }

"""

ExampleTabs = ReactiveComponent
  displayName: 'ExampleTabs'

  render: -> 
    active_example = get_example()

    examples = @props.examples 

    DIV null,

      UL 
        role: 'tablist'
        style: 
          width: "var(--SAAS_PAGE_WIDTH)"
          margin: 'auto'
          textAlign: 'left'
          listStyle: 'none'

        for example in examples
          do (example) => 
            current = example.case == active_example

            TAG = if current then H1 else DIV
            LI 
              tabIndex: 0
              role: 'tab'
              className: 'condensed example_tab'
              style: 
                backgroundColor: if current then example.case.color
                opacity: if !current then 0.3


              'aria-controls': 'active_example'
              'aria-selected': current

              onMouseEnter: => 
                if get_example() != example.case.id
                  @local.hovering = example.case
                  save @local 
              onMouseLeave: => 
                @local.hovering = null 
                save @local
              onKeyDown: (e) => 
                if e.which == 13 || e.which == 32 # ENTER or SPACE
                  e.currentTarget.click() 
                  e.preventDefault()
              onClick: => 
                set_example example.case 

                document.activeElement.blur()


              TAG 
                style: 
                  fontWeight: 400
                  color: 'white'
                example.label


styles += """
  [data-widget="Example"] {
    position: relative;
    padding-bottom: 160px;
  }

  [data-widget="Example"] .example_container {
    position: relative;
    z-index: 1;
    padding-top: 56px;
  }

  [data-widget="Example"] .example_heading {
    display: flex;
    padding-top: 48px;
    margin: auto;
  }


  [data-widget="Example"] .metrics_container {
    flex: 0;
    display: flex;
    padding-top: 24px;
    color: white;
    flex-direction: column;
  }

  [data-widget="Example"] .metric {
    text-align: center;
    margin-bottom: 36px;
  }

  [data-widget="Example"] .metric .quantity {
    font-size: 36px;
    line-height: 1;
    font-weight: 600;
  }

  [data-widget="Example"] .metric .measurable {
    font-size: 14px;
    font-weight: 500
    white-space: nowrap;
  }

  [data-widget="Example"] .screen_wrapper {
    flex: 1;
    width: calc(var(--SAAS_PAGE_WIDTH) - 180px);
  }

  @media (max-width: 1014px) {
    [data-widget="Example"] .example_container {
      padding-top: 32px;
    }
    
    [data-widget="Example"] .example_heading {
      flex-direction: column;
      padding-top: 8px;
    }
    [data-widget="Example"] .metrics_container {
      flex-direction: row;
      justify-content: center;
    }
    [data-widget="Example"] .metric {
      padding: 0 16px;
    }
    [data-widget="Example"] .metric .quantity {
      font-size: 36px;
    }
    [data-widget="Example"] .screen_wrapper {
      width: var(--SAAS_PAGE_WIDTH);
    }


  }
  @media (max-width: 500px) {
    [data-widget="Example"] .metric .quantity {
      font-size: 26px;
    }
  }

  @media (min-width: 1014px) {
    [data-widget="Example"] .screen_wrapper {
      margin-left: 60px;
    }
  }

  [data-widget="Example"] .details_label {
    font-size: 32px;
    color: white;
    padding: 12px 24px;
  }

  [data-widget="Example"] .details_wrapper {
    background-color: rgba(245,245,245,.96);
    box-shadow: 0 1px 2px rgba(0,0,0,.2);
    padding: 54px 68px 64px 68px;
    border-radius: 8px;
    width: var(--SAAS_PAGE_WIDTH);
  }

  [data-widget="Example"] .details_body {
    display: flex;
    flex-direction: row; 
  }

  [data-widget="Example"] .details_testimonial {
    flex: 1;
    position: relative;
    top: -32px;
  }

  [data-widget="Example"] .details_description {
    flex: 1;
    max-width: 600;
    padding-right: 40px;
  }
 
  @media (max-width: 570px) {
    [data-widget="Example"] .details_wrapper {
      padding: 24px 18px 42px 30px;
    }

  }

  @media (max-width: 614px) {
    [data-widget="Example"] .details_wrapper {
      width: 100vw;
    }
  }


  @media (max-width: 1014px) {

    [data-widget="Example"] .details_label {
      font-size: 22px;
    }

    [data-widget="Example"] .details_body {
      flex-direction: column; 
    }


    [data-widget="Example"] .details_testimonial {
      top: 24px;
    }

  }

"""
Example = ReactiveComponent
  displayName: 'Example'

  render: -> 
    ex = @props.case

    DIV 
      key: ex.id
      id: 'active_example'
      style: 
        background: ex.background

      A name: ex.id 

      DIV 
        className: 'example_container'


        DIV 
          style: 
            width: "var(--SAAS_PAGE_WIDTH)"
            margin: 'auto'

          H2 
            className: 'condensed main_callout'

            ex.heading 

          DIV 
            className: 'example_heading'

            DIV 
              className: 'metrics_container'

              for m, idx in ex.metrics
                continue if WINDOW_WIDTH() < 414 && idx == 1 && ex.metrics.length > 2
                DIV 
                  className: 'metric'

                  DIV 
                    className: 'quantity'
                    m.quantity

                  DIV 
                    className: 'measurable'
                    m.metric


            DIV 
              className: 'screen_wrapper'

              DIV 
                style: 
                  marginTop: 0

                A 
                  key: ex.browser_loc
                  href: ex.browser_loc
                  target: '_blank'
                  style: 
                    textDecoration: 'none'

                  ex.screen '100%'



        DIV 
          className: 'details_label'
          style: 
            width: "var(--SAAS_PAGE_WIDTH)"
            margin: 'auto'

          'Details:'

        DIV 
          className: 'details_wrapper'
          style: 
            margin: 'auto'

          H3
            className: 'bold_callout'
            ex.extra_heading

          DIV
            className: 'details_body' 

            DIV
              className: 'details_description'

              DIV 
                className: 'embedded' 
                dangerouslySetInnerHTML: {__html: ex.story}

              DIV 
                style: 
                  marginTop: 20

                "Explore at"

                if ex.links.length == 1
                  [
                    ' '
                    A
                      href: ex.links[0]
                      target: '_blank'
                      style: 
                        textDecoration: 'underline'
                        padding: "12px 8px"

                      ex.links[0]

                    if ex == cases.wsffn
                      DIV 
                        style: 
                          fontStyle: 'italic'
                        '(their board-only forum is private)'
                  ]
                else 
                  [':'
                  UL 
                    style: 
                      listStyle: 'none'
                    for link in ex.links
                      LI 
                        style: {}

                        A
                          href: link
                          target: '_blank'
                          style: 
                            textDecoration: 'underline'
                            color: '#007BC6'
                            fontWeight: 500
                            padding: "6px 8px"
                            display: 'block'

                          link                    
                  ]

            DIV 
              className: 'details_testimonial'

              TestimonialGrid
                testimonials: [ex.testimonial]
                top: true 
                italic: true
                hide_full: true




cases = {}

cases.seattle = 
  id: 'seattle'
  class: 'public_engagement'
  color: '#B4589D'
  background: '#B4589D'
  heading: 'City of Seattle transforms controversial topic into productive discussion'
  example_text: '<b>City of Seattle</b> uses Consider.it to engage residents about its affordable housing crisis'
  browser_loc: 'https://seattle2035-key-changes.consider.it/Housing'
  alt: 'Residents engage with the City of Seattle about a proposed housing affordability policy.'

  screen: (width) ->       

    Webframe 
      browser_loc: cases.seattle.browser_loc
      width: width

      DIV 
        style: 
          width: '90%'
          margin: 'auto'
        DIV 
          style: 
            fontSize: responsive_css_rule({min_size: 9, max_size: 32, min_vw: 320, max_vw: 1165})
            fontWeight: 500
            margin: '30px auto 0px auto'
            textAlign: 'center'
            maxWidth: 800
          'Increase the diversity of housing types in lower density residential zones'

        IMG 
          alt: cases.seattle.alt
          src: asset 'product_page/seattle_example.png'
          style:
            width: '100%'
            display: 'block'

  metrics: [
    {
      quantity: '8,000+'
      metric: 'opinions given'
    }
    {
      quantity: '1,500+'
      metric: 'comments'
    }
    {
      quantity: '0'
      metric: 'personal attacks'
    }


  ]

  extra_heading: 'Civil public dialogue on contentious issues.'
  story: """<p>Seattle is booming. Affordable housing is vanishing.</p>
            <p>The City of Seattle launched an <a href='https://www.seattle.gov/hala'>ambitious plan</a> to dramatically increase the supply of affordable housing.</p>
            <p>Consider.it is helping Seattle engage local residents in developing the plan. Every resident has the opportunity to provide feedback on how the plan will impact them.</p>
            <p>The structure of the Consider.it forum has encouraged civil dialogue. Neighbors are learning from each other. Neighbors are participating in building a better city. The feedback City staff receive is higher quality than other online sources, and many public meetings.</p>"""
  links: ['https://hala.consider.it', 'https://seattle2035-key-changes.consider.it', 'https://engageseattle.consider.it', 'https://yvyc.consider.it', 'https://nsf.consider.it']
  testimonial: testimonials.susie



cases.wsffn = 
  id: 'wsffn'
  class: 'strategic_planning'  
  background: 'linear-gradient(143deg, #9BA43D 35%, #7D8928 100%)'
  color: '#9BA43D'
  heading: 'Statewide non-profit makes strategic plan for a fraction of the cost of a traditional process'
  example_text: 'statewide non-profit made strategic plan for a fraction of the cost of a traditional process'
  browser_loc: 'https://wsffn.consider.it'
  alt: 'Stakeholders of the non-profit engage about key changes in proposed strategic plan.'
  screen: (width) ->       
    Webframe 
      browser_loc: cases.wsffn.browser_loc
      width: width
      DIV 
        style: 
          width: '90%'
          margin: 'auto'

        IMG 
          alt: cases.wsffn.alt
          src: asset 'product_page/wsffn_example.png'
          style:
            width: '100%'
            display: 'block'

  metrics: [
    {
      quantity: '40'
      metric: 'stakeholders'
    }
    {
      quantity: '$4,000'
      metric: 'tech + consulting'
    }
    {
      quantity: '1'
      metric: 'adopted plan'
    }


  ]

  extra_heading: 'Lightweight strategic planning on a tight budget.'
  story: """
        <p>Russ Lehman had a problem. He had just been hired as the director of the Washington Sustainable Food and Farming Network. WSFFN needed a new strategic plan, including a new name. And he needed to engage his members across the state in vetting and ultimately supporting the changes. All on a shoe-string budget.</p>
        <p>Russ set up a Consider.it forum and gathered feedback on the core points of the new plan over several weeks. Russ could now see at a glance points of agreement amongst stakeholders, as well as sticking points that he'd have to navigate.</p>
        <p>With newfound confidence, Russ drafted a full plan and proposed it to the board via a private Consider.it forum. The board used Consider.it to refine and ultimately adopt the new plan. Now they are using Consider.it to identify a new organization name.</p> 
        <p>Consider.it helped get the organization pointed in the same direction and helped all stakeholders feel they were heard.</p>
        <p><b>Total cost</b>: $4k.</p>
        """
  links: ['https://wsffn.consider.it']
  testimonial: testimonials.russ



cases.dao = 
  id: 'dao'
  class: 'decentralized_decisions'  
  background: 'linear-gradient(141deg, #348AC7 35%, #7474BF 100%)'
  color: '#348AC7'
  heading: 'Worldwide decentralized network deliberates how to spend $150m'
  example_text: 'Worldwide decentralized internet community deliberated how to spend $150m'
  alt: "Decentralized internet community discusses a proposal."
  browser_loc: 'https://dao.consider.it/temporary-moratorium-on-the-dao-security-issues'
  screen: (width) ->       
    Webframe 
      browser_loc: cases.dao.browser_loc
      width: width 

      DIV 
        style: 
          width: '90%'
          margin: 'auto'

        DIV 
          style: 
            fontSize: Math.min 32, Math.round(32 * WINDOW_WIDTH() / 1165)
            fontWeight: 500
            margin: '30px auto 20px auto'
            textAlign: 'center'
            maxWidth: 800
          'Temporary moratorium for security audit'

        IMG 
          alt: cases.dao.alt        
          src: asset 'product_page/dao_example.png'
          style:
            width: '100%'
            display: 'block'

  metrics: [
    {
      quantity: '10,000+'
      metric: 'opinions given'
    }
    {
      quantity: '1,500+'
      metric: 'participants'
    }
    {
      quantity: '400+'
      metric: 'ideas deliberated'
    }


  ]

  extra_heading: 'Make decisions at scale, without hierarchy.'
  story: """<p>The DAO was a prominent attempt to create a decentralized cooperative organization existing entirely on the internet. It set records in raising $150m of crowdfunding from thousands of individuals.</p> 
        <p>The DAO had many challenges to overcome as an unprecedented social experiment. The community adopted Consider.it to help address one of these problems: aggregating and gauging community support about (1) what to invest in and (2) how to self-govern. Consider.it delivered: it became the community's primary forum for deliberating ideas and gauging community sentiment. </p>
        """ #        <p>Unfortunately, a security flaw in The DAO itself ultimately undermined the project and the experiment came to an end.</p>

  links: ['https://dao.consider.it']
  testimonial: testimonials.auryn



cases.aina = 
  id: 'aina'
  class: 'community_visioning'
  color: '#517ecb'
  background: '#517ecb'
  heading: 'Native Hawaiians lead effort to create a new vision for the islands in the space created by pandemic'
  browser_loc: 'https://ainaalohafutures.consider.it/should-we-support-a-proposal-to-require-students-from-kindergarten-through-college-to-engage-i-rethinking-education-15168'
  alt: 'Hawaiian community deliberates an idea about helping kids learn financial literacy.'
  screen: (width) ->       
    Webframe 
      browser_loc: cases.aina.browser_loc
      width: width

      IMG 
        alt: cases.aina.alt      
        src: asset 'product_page/aina_example.png'
        style:
          width: '100%'
          display: 'block'

  metrics: [
    {
      quantity: '400+'
      metric: 'participants'
    }
    {
      quantity: '3,000+'
      metric: 'opinions given'
    }
    {
      quantity: '150+'
      metric: 'proposals'
    }
    {
      quantity: '4+'
      metric: 'bills influenced'
    }


  ]

  extra_heading: 'Organizing for a regenerative future.'
  story: """
    <p>
    <i>In Kēhau's words:</i>
    </p>
    <p>
    <a href="https://www.ainaalohafutures.com/" target="_blank">‘Āina Aloha Economic Futures</a> (AAEF) formed 
    in response to the reset opportunity COVID provided us in Hawaiʻi. 
    From spontaneous conversations among like-minded friends arose the idea to organize larger community 
    conversations to set a new course for Hawaiʻi. We drafted 
    <a href="https://www.ainaalohafutures.com/declaration" target="_blank">core values</a>, 
    an <a href="https://www.ainaalohafutures.com/action-agenda" target="_blank">action agenda</a>, and 
    organized <a href="https://www.ainaalohafutures.com/proposals" target="_blank">14 virtual community sessions</a> 
    open to all, which encouraged participants from across our 
    island chain to offer proposal sketches for policy changes and action initiatives.
    </p>

    <p>
    Following those sessions, Consider.it enabled us to continue a meaningful, productive one-month 
    virtual conversation about improving Hawaiʻi’s future.
    With minimal guidance (a quick sharing of the Consider.it tutorial video), participants could 
    easily offer their general level of agreement or disagreement regarding each proposal, share 
    as many succinct pro/con comments as they wished regarding the proposals, read what 
    others had to say about the proposals, and adopt comments that resonated with them. 
    In real time, Consider.it created an intuitive pictorial graph of everyone’s level of 
    support for a proposal, along with the underlying reasoning.
    </p>


    <p>All told, these Consider.it discussions involved 
    nearly 500 participants who offered over 3,250 assessments of 192 proposals. Consider.it was the ideal tool 
    for us to facilitate this level of engagement. Anyone hoping to coordinate a community-wide conversation in a 
    way that’s easy for participants and productive for organizers would greatly benefit from 
    including Consider.it in their process. 
    </p>

    <p>
    Furthermore, the Consider.it record of the robust online conversation we held has proven invaluable. We were able to develop a 
    <a href="https://docs.google.com/document/d/1GJdVPM84fA0x9UBGpii0UjBgvEiV4INr2ES5FXmRpjk/edit" target="_blank">Policy Playbook</a> 
    that spotlighted salient points raised through the proposals and the Consider.it discussion of them. It helped AAEF garner 
    <a href="https://docs.google.com/spreadsheets/d/1WNkdsyhd-whH58dE-6819oFmVVHur0c0V41Rl7fL33E/edit#gid=0" target="_blank">many additional signatories</a> 
    supporting the effort, including three of four county mayors, three of four county councils, the largest private landowner 
    in Hawai’i (Kamehameha Schools), the state government agency charged with overseeing Hawaiʻi’s visitor industry 
    (Hawai’i Tourism Authority), and the University of Hawaiʻi John A. Burns School of Medicine.
    </p>


    <p>
    Hawai’i state and county policy makers who each received a copy of the Playbook could readily see in our Consider.it 
    record that a large community of engaged participants collectively arrived at the proposals offered in it, 
    affording the Playbook a significant degree of impact. While AAEF did not actively lead the way in specific legislative 
    bills this session, the overall momentum the AAEF Consider.it results produced played a contributing role in 
    the passage of bills relating to climate change mitigation, sustainable agriculture, raising the minimum wage, 
    and protections for traditional water rights. 
    </p>
    """
  links: ['https://ainaalohafutures.consider.it/', 'https://www.ainaalohafutures.com/']
  testimonial: testimonials.kehau_example



/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/examples_page.coffee
 **/